import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './assets/fonts/font.css'
import './assets/css/common.less'
import  'amfe-flexible';
import 'lib-flexible'
import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx;
Vue.use(Vant);
Vue.use(Lazyload, {
  lazyComponent: true
});

import {DELETE} from './api/axios';
import {POST} from './api/axios';
import {GET} from './api/axios';
import {PUT} from './api/axios';
import {publicGET} from './api/axios';
Vue.prototype.postRequest = POST;
Vue.prototype.getRequest = GET;
Vue.prototype.deleteRequest = DELETE;
Vue.prototype.putRequest = PUT;
Vue.prototype.publicGETRequest = publicGET;
Vue.config.productionTip = false

// import common from './assets/js/common'
// Vue.prototype.$common = common;
import common from './assets/js/common'
Object.keys(common).map((item) => {
  Vue.prototype[item] = common[item]
})



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});
